"use strict";


import init from "./vbcn";





// Document is ready!
document.addEventListener( 'DOMContentLoaded', function( event ) {
    init();
});
